export const MergeStateReducer = (prevState, updatedProperty) => ({
    ...prevState,
    ...updatedProperty,
});